import { LastMovement } from './LastMovement.entity';

export class LastTransaction {
  constructor(
    public page: number,
    public totalPages: number,
    public lastMovements: LastMovement[]
  ) {}
}
